<template>
  <div class="content gift">
    <div class="core">
      <table id="dataTable">
        <tr>
          <th v-for="key in keys" v-bind:key="key">
            {{ key }}
          </th>
        </tr>

        <tr v-for="(item) in transaction" v-bind:key="item._id">
          <td>
            {{ item.user.email }}
          </td>
          <td>
            {{ item.paidBy.email }}
          </td>
          <td>
            {{ item.promocode ? item.promocode.code : 'Нет' }}
          </td>
          <td>
            {{ item.created_at }}
          </td>
          <td>
            {{ item.paid_at ? item.paid_at : '-' }}
          </td>
          <td>
            {{ item.status.title }}
          </td>
        </tr>
      </table>
    </div>

    <Pagination @setpage="setPage" :current="page" :pages="totalCount" :page="page" :perPage="10"/>
  </div>
</template>


<script>
// import DataTable from "../components/views/DataTable";
import Pagination from "../components/Pagination";
import axios from "axios";

export default {

  components: {
    Pagination
  },

  data() {
    return {
      page: 1,
      totalCount: 1,
      keys: ["Кто", "Кому", "Промокод", "Дата создания", "Дата оплаты", "Статус оплаты"],
      transaction: [],
    }
  },


  mounted() {
    this.loadData()
  },

  methods: {
    setPage(data) {
      this.page = data.page
      this.loadData()
    },
    loadData() {
      axios.get('/transaction', {
        params: {
          page: this.page
        }
      }).then(
          (resp) => {
            this.transaction = resp.data.data
            this.totalCount = resp.data.totalCount
          }
      )
    }
  }
}
</script>


<style>
.gift {
  display: block !important;
}

.gift .core {
  height: calc(100% - 5.7vw);
}

.gift #dataTable {
  font-size: 0.8vw;
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  border-color: #DDD;
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
}

.gift #dataTable td, .gift #dataTable th {
  border: 1px solid #ddd;
  padding-left: 2vw;
  padding-top: 1vw;
  padding-right: 2vw;
  padding-bottom: 1vw;
}

.gift #dataTable th {
  text-align: left;
  color: #999;
}
</style>
